import * as z from "zod/v4";
import { IntegrationV2Schema } from "./integration-v2.js";
const GetIntegrationsV2ResponseSchema_ = z.object({
    integrations: z.array(IntegrationV2Schema),
});
export const GetIntegrationsV2ResponseSchema = GetIntegrationsV2ResponseSchema_;
//# sourceMappingURL=get-integrations-v2-response.js.map